import { render, staticRenderFns } from "./IconCart.vue?vue&type=template&id=7a93c9f4&"
import script from "./IconCart.vue?vue&type=script&lang=ts&"
export * from "./IconCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports